"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.addReserve = exports.initLendingMarket = exports.SolendReserveAsset = void 0;
const buffer_layout_1 = require("buffer-layout");
const bigint_buffer_1 = require("bigint-buffer");
const big_js_1 = __importDefault(require("big.js"));
const web3_js_1 = require("@solana/web3.js");
const spl_token_1 = require("@solana/spl-token");
const anchor = __importStar(require("@project-serum/anchor"));
const solend_sdk_1 = require("@solendprotocol/solend-sdk");
const common_1 = require("@solendprotocol/solend-sdk/dist/examples/common");
const asset_1 = require("./asset");
const utils_1 = require("../utils");
const utils_2 = require("./utils");
class SolendReserveAsset extends asset_1.LendingMarket {
    constructor(provider, accounts, reserve, reserveToken, lpToken) {
        super();
        this.provider = provider;
        this.accounts = accounts;
        this.reserve = reserve;
        this.reserveToken = reserveToken;
        this.lpToken = lpToken;
    }
    // TODO change to connection instead of provider so it doesn't need to be reloaded when wallet changes
    static load(provider, cluster, reserveMint) {
        return __awaiter(this, void 0, void 0, function* () {
            let market;
            if (cluster == "devnet") {
                market = yield solend_sdk_1.SolendMarket.initialize(provider.connection, "devnet");
            }
            else if (cluster == "mainnet-beta") {
                market = yield solend_sdk_1.SolendMarket.initialize(provider.connection, "production");
            }
            else {
                throw new Error("Cluster ${cluster} not supported");
            }
            yield market.loadReserves();
            const reserve = market.reserves.find((res) => res.config.mintAddress == reserveMint.toBase58());
            const accounts = {
                program: new web3_js_1.PublicKey(market.config.programID),
                market: new web3_js_1.PublicKey(market.config.address),
                marketAuthority: new web3_js_1.PublicKey(market.config.authorityAddress),
                reserve: new web3_js_1.PublicKey(reserve.config.address),
                pythPrice: new web3_js_1.PublicKey(reserve.config.priceAddress),
                switchboardFeed: new web3_js_1.PublicKey(reserve.config.switchboardFeedAddress),
                collateralMint: new web3_js_1.PublicKey(reserve.config.collateralMintAddress),
                liquiditySupply: new web3_js_1.PublicKey(reserve.config.liquidityAddress),
            };
            const lpToken = yield (0, utils_2.getToken)(provider.connection, new web3_js_1.PublicKey(reserve.config.collateralMintAddress));
            const reserveToken = yield (0, utils_2.getToken)(provider.connection, new web3_js_1.PublicKey(reserve.config.mintAddress));
            return new SolendReserveAsset(provider, accounts, reserve, reserveToken, lpToken);
        });
    }
    static initialize(provider, owner, wallet, reserveTokenMint, pythProgram, switchboardProgram, pythProduct, pythPrice, switchboardFeed, ownerReserveTokenAccount, initialReserveAmount) {
        return __awaiter(this, void 0, void 0, function* () {
            const marketKeypair = yield initLendingMarket(provider, owner.publicKey, wallet.payer, pythProgram, switchboardProgram);
            const accounts = yield addReserve(provider, initialReserveAmount, ownerReserveTokenAccount, owner, wallet.payer, reserveTokenMint, pythProduct, pythPrice, switchboardFeed, marketKeypair.publicKey);
            // Mostly dummy info since we don't use any of it
            const reserve = new solend_sdk_1.SolendReserve({
                priceAddress: pythPrice.toBase58(),
                switchboardFeedAddress: switchboardFeed.toBase58(),
                name: "",
                mintAddress: reserveTokenMint.toBase58(),
                asset: "",
                collateralMintAddress: accounts.collateralMint.toBase58(),
                decimals: 8,
                liquidityAddress: accounts.liquiditySupply.toBase58(),
                liquidityFeeReceiverAddress: "",
                symbol: "",
                address: accounts.reserve.toBase58(),
                collateralSupplyAddress: "",
            }, yield solend_sdk_1.SolendMarket.initialize(provider.connection, "devnet"), provider.connection);
            const lpToken = yield (0, utils_2.getToken)(provider.connection, new web3_js_1.PublicKey(reserve.config.collateralMintAddress));
            const reserveToken = yield (0, utils_2.getToken)(provider.connection, reserveTokenMint);
            return new SolendReserveAsset(provider, accounts, reserve, reserveToken, lpToken);
        });
    }
    //async borrow(amount: number): Promise<TransactionSignature> {
    //    const borrowTx = SolendAction.buildBorrowTxns(
    //        this.provider.connection,
    //        new anchor.BN(amount),
    //
    //    )
    //}
    reload() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.reserve.load();
        });
    }
    getLpTokenAccountValue(address) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.reload();
            const lpToken = new spl_token_1.Token(this.provider.connection, this.lpToken.mint, spl_token_1.TOKEN_PROGRAM_ID, web3_js_1.Keypair.generate() // dummy signer since we aren't making any txs
            );
            const lpTokenAmount = new big_js_1.default((yield lpToken.getAccountInfo(address)).amount.toString());
            const exchangeRate = new big_js_1.default(this.reserve.stats.cTokenExchangeRate);
            return utils_1.TokenAmount.fromToken(this.reserveToken, lpTokenAmount.mul(exchangeRate).round(0, big_js_1.default.roundDown));
        });
    }
    /**
     *
     * @todo make this the same as program's calculation
     *
     * @returns
     */
    getApy() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.reload();
            const apr = this.reserve.stats.supplyInterestAPY;
            const apy = Math.expm1(apr);
            return new utils_1.Rate((0, big_js_1.default)(apy));
        });
    }
    getBorrowedAmount() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.reload();
            return utils_1.TokenAmount.fromToken(this.reserveToken, (0, big_js_1.default)(this.reserve.stats.totalBorrowsWads
                .div(new anchor.BN(common_1.WAD))
                .toString()));
        });
    }
    getDepositedAmount() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.reload();
            return utils_1.TokenAmount.fromToken(this.reserveToken, (0, big_js_1.default)(this.reserve.stats.totalDepositsWads
                .div(new anchor.BN(common_1.WAD))
                .toString()));
        });
    }
}
exports.SolendReserveAsset = SolendReserveAsset;
const DEVNET_PROGRAM_ID = new web3_js_1.PublicKey("ALend7Ketfx5bxh6ghsCDXAoDrhvEmsXT3cynB6aPLgx");
function initLendingMarket(provider, owner, payer, pythProgramId, switchboardProgramId) {
    return __awaiter(this, void 0, void 0, function* () {
        const lendingMarketAccount = anchor.web3.Keypair.generate();
        const balanceNeeded = yield provider.connection.getMinimumBalanceForRentExemption(solend_sdk_1.LENDING_MARKET_SIZE);
        const initTx = new anchor.web3.Transaction()
            .add(web3_js_1.SystemProgram.createAccount({
            fromPubkey: payer.publicKey,
            newAccountPubkey: lendingMarketAccount.publicKey,
            lamports: balanceNeeded,
            space: solend_sdk_1.LENDING_MARKET_SIZE,
            programId: DEVNET_PROGRAM_ID,
        }))
            .add(initLendingMarketInstruction(owner, quoteCurrency("USD"), lendingMarketAccount.publicKey, pythProgramId, switchboardProgramId, DEVNET_PROGRAM_ID));
        yield provider.send(initTx, [payer, lendingMarketAccount]);
        return lendingMarketAccount;
    });
}
exports.initLendingMarket = initLendingMarket;
function addReserve(provider, liquidityAmount, ownerReserveTokenAccount, owner, payer, reserveTokenMint, pythProduct, pythPrice, switchboardFeed, lendingMarket) {
    return __awaiter(this, void 0, void 0, function* () {
        const RESERVE_SIZE = 619;
        const collateralMint = anchor.web3.Keypair.generate();
        const [lendingMarketAuthority] = yield web3_js_1.PublicKey.findProgramAddress([lendingMarket.toBuffer()], DEVNET_PROGRAM_ID);
        const reserve = anchor.web3.Keypair.generate();
        const liquiditySupply = anchor.web3.Keypair.generate();
        const collateralSupply = anchor.web3.Keypair.generate();
        const liquidityFeeReceiver = anchor.web3.Keypair.generate();
        const userCollateral = anchor.web3.Keypair.generate();
        const userTransferAuthority = anchor.web3.Keypair.generate();
        const reserveBalance = yield provider.connection.getMinimumBalanceForRentExemption(RESERVE_SIZE);
        const mintBalance = yield provider.connection.getMinimumBalanceForRentExemption(spl_token_1.MintLayout.span);
        const accountBalance = yield provider.connection.getMinimumBalanceForRentExemption(spl_token_1.AccountLayout.span);
        const tx1 = new anchor.web3.Transaction()
            .add(web3_js_1.SystemProgram.createAccount({
            fromPubkey: payer.publicKey,
            newAccountPubkey: reserve.publicKey,
            lamports: reserveBalance,
            space: RESERVE_SIZE,
            programId: DEVNET_PROGRAM_ID,
        }))
            .add(web3_js_1.SystemProgram.createAccount({
            fromPubkey: payer.publicKey,
            newAccountPubkey: collateralMint.publicKey,
            lamports: mintBalance,
            space: spl_token_1.MintLayout.span,
            programId: spl_token_1.TOKEN_PROGRAM_ID,
        }))
            .add(web3_js_1.SystemProgram.createAccount({
            fromPubkey: payer.publicKey,
            newAccountPubkey: collateralSupply.publicKey,
            lamports: accountBalance,
            space: spl_token_1.AccountLayout.span,
            programId: spl_token_1.TOKEN_PROGRAM_ID,
        }))
            .add(web3_js_1.SystemProgram.createAccount({
            fromPubkey: payer.publicKey,
            newAccountPubkey: userCollateral.publicKey,
            lamports: accountBalance,
            space: spl_token_1.AccountLayout.span,
            programId: spl_token_1.TOKEN_PROGRAM_ID,
        }));
        const tx2 = new anchor.web3.Transaction()
            .add(web3_js_1.SystemProgram.createAccount({
            fromPubkey: payer.publicKey,
            newAccountPubkey: liquiditySupply.publicKey,
            lamports: accountBalance,
            space: spl_token_1.AccountLayout.span,
            programId: spl_token_1.TOKEN_PROGRAM_ID,
        }))
            .add(web3_js_1.SystemProgram.createAccount({
            fromPubkey: payer.publicKey,
            newAccountPubkey: liquidityFeeReceiver.publicKey,
            lamports: accountBalance,
            space: spl_token_1.AccountLayout.span,
            programId: spl_token_1.TOKEN_PROGRAM_ID,
        }));
        const reserveConfig = {
            optimalUtilizationRate: 80,
            loanToValueRatio: 50,
            liquidationBonus: 5,
            liquidationThreshold: 55,
            minBorrowRate: 0,
            optimalBorrowRate: 4,
            maxBorrowRate: 30,
            fees: {
                /// 0.00001% (Aave borrow fee)
                borrowFeeWad: BigInt(100000000000),
                /// 0.3% (Aave flash loan fee)
                flashLoanFeeWad: BigInt(3000000000000000),
                hostFeePercentage: 20,
            },
            depositLimit: BigInt(100000000000),
            borrowLimit: BigInt(100000000000),
            feeReceiver: liquidityFeeReceiver.publicKey,
        };
        const tx3 = new anchor.web3.Transaction()
            .add(spl_token_1.Token.createApproveInstruction(spl_token_1.TOKEN_PROGRAM_ID, ownerReserveTokenAccount, userTransferAuthority.publicKey, owner.publicKey, [], liquidityAmount))
            .add(initReserveInstruction(liquidityAmount, reserveConfig, ownerReserveTokenAccount, userCollateral.publicKey, reserve.publicKey, reserveTokenMint, liquiditySupply.publicKey, liquidityFeeReceiver.publicKey, pythProduct, pythPrice, collateralMint.publicKey, collateralSupply.publicKey, lendingMarket, lendingMarketAuthority, owner.publicKey, userTransferAuthority.publicKey, switchboardFeed, DEVNET_PROGRAM_ID));
        yield provider.sendAll([
            {
                tx: tx1,
                signers: [
                    payer,
                    reserve,
                    collateralMint,
                    collateralSupply,
                    userCollateral,
                ],
            },
            { tx: tx2, signers: [payer, liquiditySupply, liquidityFeeReceiver] },
            { tx: tx3, signers: [payer, owner, userTransferAuthority] },
        ]);
        return {
            program: DEVNET_PROGRAM_ID,
            reserve: reserve.publicKey,
            pythPrice: pythPrice,
            switchboardFeed: switchboardFeed,
            collateralMint: collateralMint.publicKey,
            liquiditySupply: liquiditySupply.publicKey,
            market: lendingMarket,
            marketAuthority: lendingMarketAuthority,
        };
    });
}
exports.addReserve = addReserve;
const quoteCurrency = (s) => {
    const buf = Buffer.alloc(32);
    const strBuf = Buffer.from(s);
    strBuf.copy(buf, 0);
    return buf;
};
const encodeDecode = (layout) => {
    const decode = layout.decode.bind(layout);
    const encode = layout.encode.bind(layout);
    return { decode, encode };
};
const publicKey = (property = "publicKey") => {
    const layout = (0, buffer_layout_1.blob)(32, property);
    const { encode, decode } = encodeDecode(layout);
    const publicKeyLayout = layout;
    publicKeyLayout.decode = (buffer, offset) => {
        const src = decode(buffer, offset);
        return new web3_js_1.PublicKey(src);
    };
    publicKeyLayout.encode = (publicKey, buffer, offset) => {
        const src = publicKey.toBuffer();
        return encode(src, buffer, offset);
    };
    return publicKeyLayout;
};
const initLendingMarketInstruction = (owner, quoteCurrency, lendingMarket, pythOracle, switchboardOracle, lendingProgram) => {
    const DataLayout = (0, buffer_layout_1.struct)([
        (0, buffer_layout_1.u8)("instruction"),
        publicKey("owner"),
        (0, buffer_layout_1.blob)(32, "quoteCurrency"),
    ]);
    const data = Buffer.alloc(DataLayout.span);
    DataLayout.encode({
        instruction: 0,
        owner,
        quoteCurrency,
    }, data);
    const keys = [
        { pubkey: lendingMarket, isSigner: false, isWritable: true },
        { pubkey: web3_js_1.SYSVAR_RENT_PUBKEY, isSigner: false, isWritable: false },
        { pubkey: spl_token_1.TOKEN_PROGRAM_ID, isSigner: false, isWritable: false },
        { pubkey: pythOracle, isSigner: false, isWritable: false },
        { pubkey: switchboardOracle, isSigner: false, isWritable: false },
    ];
    return new web3_js_1.TransactionInstruction({
        keys,
        programId: lendingProgram,
        data,
    });
};
const bigInt = (length) => (property = "bigInt") => {
    const layout = (0, buffer_layout_1.blob)(length, property);
    const { encode, decode } = encodeDecode(layout);
    const bigIntLayout = layout;
    bigIntLayout.decode = (buffer, offset) => {
        const src = decode(buffer, offset);
        return (0, bigint_buffer_1.toBigIntLE)(src);
    };
    bigIntLayout.encode = (bigInt, buffer, offset) => {
        const src = (0, bigint_buffer_1.toBufferLE)(bigInt, length);
        return encode(src, buffer, offset);
    };
    return bigIntLayout;
};
const u64 = bigInt(8);
const ReserveFeesLayout = (0, buffer_layout_1.struct)([u64("borrowFeeWad"), u64("flashLoanFeeWad"), (0, buffer_layout_1.u8)("hostFeePercentage")], "fees");
const ReserveConfigLayout = (0, buffer_layout_1.struct)([
    (0, buffer_layout_1.u8)("optimalUtilizationRate"),
    (0, buffer_layout_1.u8)("loanToValueRatio"),
    (0, buffer_layout_1.u8)("liquidationBonus"),
    (0, buffer_layout_1.u8)("liquidationThreshold"),
    (0, buffer_layout_1.u8)("minBorrowRate"),
    (0, buffer_layout_1.u8)("optimalBorrowRate"),
    (0, buffer_layout_1.u8)("maxBorrowRate"),
    ReserveFeesLayout,
    u64("depositLimit"),
    u64("borrowLimit"),
    publicKey("feeReceiver"),
], "config");
const initReserveInstruction = (liquidityAmount, config, sourceLiquidity, destinationCollateral, reserve, liquidityMint, liquiditySupply, liquidityFeeReceiver, pythProduct, pythPrice, collateralMint, collateralSupply, lendingMarket, lendingMarketAuthority, lendingMarketOwner, transferAuthority, switchboardFeed, lendingProgram) => {
    const DataLayout = (0, buffer_layout_1.struct)([
        (0, buffer_layout_1.u8)("instruction"),
        u64("liquidityAmount"),
        ReserveConfigLayout,
    ]);
    const data = Buffer.alloc(DataLayout.span);
    DataLayout.encode({
        instruction: 2,
        liquidityAmount: BigInt(liquidityAmount),
        config,
    }, data);
    const keys = [
        { pubkey: sourceLiquidity, isSigner: false, isWritable: true },
        { pubkey: destinationCollateral, isSigner: false, isWritable: true },
        { pubkey: reserve, isSigner: false, isWritable: true },
        { pubkey: liquidityMint, isSigner: false, isWritable: false },
        { pubkey: liquiditySupply, isSigner: false, isWritable: true },
        { pubkey: liquidityFeeReceiver, isSigner: false, isWritable: true },
        { pubkey: collateralMint, isSigner: false, isWritable: true },
        { pubkey: collateralSupply, isSigner: false, isWritable: true },
        { pubkey: pythProduct, isSigner: false, isWritable: false },
        { pubkey: pythPrice, isSigner: false, isWritable: false },
        { pubkey: switchboardFeed, isSigner: false, isWritable: false },
        { pubkey: lendingMarket, isSigner: false, isWritable: true },
        { pubkey: lendingMarketAuthority, isSigner: false, isWritable: false },
        { pubkey: lendingMarketOwner, isSigner: true, isWritable: false },
        { pubkey: transferAuthority, isSigner: true, isWritable: false },
        { pubkey: web3_js_1.SYSVAR_CLOCK_PUBKEY, isSigner: false, isWritable: false },
        { pubkey: web3_js_1.SYSVAR_RENT_PUBKEY, isSigner: false, isWritable: false },
        { pubkey: spl_token_1.TOKEN_PROGRAM_ID, isSigner: false, isWritable: false },
    ];
    return new web3_js_1.TransactionInstruction({
        keys,
        programId: lendingProgram,
        data,
    });
};
//# sourceMappingURL=solend.js.map